import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { AppBackendRequestActions, AppDispatch } from '@fullstory/redux';
import { getOrgId } from '@fullstory/redux/modules/fullstory/selectors';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type Options = {
  /**
   * For use when the call to mark the object as viewed is conditional.
   *
   * @default true
   */
  enabled?: boolean;
  /**
   * When true, will only trigger the object viewed call once per mount with the
   * same object id and type.
   *
   * @default false
   */
  triggerOnce?: boolean;
};

export function useObjectViewed(
  dxObjectId: string | null | undefined,
  dxObjectType: ObjectType | null | undefined,
  options: Options = {},
) {
  const { enabled = true, triggerOnce = false } = options;
  const dispatch = useDispatch<AppDispatch>();
  const orgId = useSelector(getOrgId);
  const lastCalledWith = useRef<{
    dxObjectId: string;
    dxObjectType: ObjectType;
  } | null>(null);

  useEffect(() => {
    if (
      enabled &&
      dxObjectId &&
      dxObjectType &&
      (!triggerOnce ||
        !lastCalledWith.current ||
        dxObjectId !== lastCalledWith.current.dxObjectId ||
        dxObjectType !== lastCalledWith.current.dxObjectType)
    ) {
      dispatch(AppBackendRequestActions.objectViewed({ orgId, dxObjectId, dxObjectType }));
      lastCalledWith.current = {
        dxObjectId,
        dxObjectType,
      };
    }
  }, [dispatch, dxObjectId, dxObjectType, enabled, triggerOnce, orgId]);
}
